/** Set by `main.tsx` after `registerSW()` resolves — used by `SwUpdateBanner` to activate a waiting worker. */

let applyUpdate: ((reloadPage?: boolean) => Promise<void>) | null = null

export const SW_UPDATE_AVAILABLE_EVENT = 'swish-pwa-update-available'

export function emitServiceWorkerUpdateAvailable(): void {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent(SW_UPDATE_AVAILABLE_EVENT))
}

export function setServiceWorkerApplyUpdate(fn: ((reloadPage?: boolean) => Promise<void>) | null): void {
  applyUpdate = fn
}

export function applyPendingServiceWorkerUpdate(): Promise<void> {
  return applyUpdate?.() ?? Promise.resolve()
}
